window.phoneFrames = {

  // =========================
  // APPLE
  // =========================

  "iphone-air": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone-Air.png?v=1783761241",
  "iphone-17": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone-17.png?v=1783761241",
  "iphone-17-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone-17-Pro.png?v=1783957711",
  "iphone-17-pro-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone-17-Pro-Max.png?v=1783957745",

  "iphone-16": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_16.png?v=1783945190",
  "iphone-16e": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_16e.png?v=1783945228",
  "iphone-16-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_16_Plus.png?v=1783945226",
  "iphone-16-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_16_Pro.png?v=1783945227",
  "iphone-16-pro-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_16_Pro_Max_f6420188-e8de-40b1-ae90-5464d21ba5e6.png?v=1783945227",

  "iphone-15": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_15.png?v=1783945228",
  "iphone-15-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_15_Plus.png?v=1783945227",
  "iphone-15-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_15_Pro.png?v=1783945227",
  "iphone-15-pro-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_15_Pro_max.png?v=1783945227",

  "iphone-14": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_14.png?v=1783945227",
  "iphone-14-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_14_Plus.png?v=1783945228",
  "iphone-14-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_14_Pro.png?v=1783945228",
  "iphone-14-pro-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_14_Pro_max.png?v=1783945228",

  "iphone-13": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_13.png?v=1783945227",
  "iphone-13-mini": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_13_Mini.png?v=1783945223",
  "iphone-13-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_13_Pro.png?v=1783945228",
  "iphone-13-pro-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_13_Pro_Max.png?v=1783945228",

  "iphone-12": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_12.png?v=1783945227",
  "iphone-12-mini": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_12_Mini.png?v=1783945228",
  "iphone-12-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_12_Pro.png?v=1783945228",
  "iphone-12-pro-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_12_Pro_Max.png?v=1783945226",

  "iphone-11": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_11.png?v=1783945227",
  "iphone-11-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_11_Pro.png?v=1783945228",
  "iphone-11-pro-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_11_Pro_Max.png?v=1783945228",

  "iphone-x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_X.png?v=1783945228",
  "iphone-xr": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_XR.png?v=1783945228",
  "iphone-xs": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_XS.png?v=1783945228",
  "iphone-xs-max": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iPhone_XS_Max.png?v=1783945228",

  "iphone-6/6s": "",

  // =========================
  // SAMSUNG
  // =========================

  "galaxy-a14-5g": "",
  "galaxy-a15": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy-A15-5G.png?v=1784193992",
  "galaxy-a16": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_A16_5G.png?v=1783950317",
  "galaxy-a23": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_A23.png?v=1784031292",
  "galaxy-a25-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy-A25-5g.png?v=1784193992",
  "galaxy-a33-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_A33_5G.png?v=1784031282",
  "galaxy-a34": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_A34.png?v=1784031292",
  "galaxy-a35": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_A35_5G.png?v=1783950317",
  "galaxy-a36": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_A36_3ca86607-461e-40af-abe5-3d4da90b1bb8.png?v=1784031292",
  "galaxy-a37": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_A37_37bfdb51-2686-4706-9c7b-6b710fc963ec.png?v=1784117366",
  "galaxy-a51": "",
  "galaxy-a52": "",
  "galaxy-a52s": "",
  "galaxy-a54": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_A54.png?v=1784031292",
  "galaxy-a55": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_A55_5G_f81147ef-ce84-4538-a9f8-5421b68c9c7e.png?v=1784031292",
  "galaxy-a56": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_A56_5G.png?v=1783950317",
  "galaxy-a71": "",
  "galaxy-a73": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_A73.png?v=1784031292",

  "galaxy-f14": "",
  "galaxy-f15": "",
  "galaxy-f23": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_F23.png?v=1784031292",
  "galaxy-f34": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_F34.png?v=1784031292",
  "galaxy-f36": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_F36.png?v=1784031292",
  "galaxy-f41": "",
  "galaxy-f54": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_F54.png?v=1784031291",
  "galaxy-f55": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_F55.png?v=1784031292",
  "galaxy-f56": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/GALAXY-F56-5G.png?v=1784193992",

  "galaxy-m56": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/GALAXY-M56-5G.png?v=1784193992",
  "galaxy-m55": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_M55_5G_4e4e2e49-1536-4697-9c6e-355f5c21e633.png?v=1784031292",
  "galaxy-m53": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy-M53-5G.png?v=1784193992",
  "galaxy-m52-5g": "",
  "galaxy-m51": "",
  "galaxy-m36": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_M36.png?v=1783950317",
  "galaxy-m35": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_M35_5G.png?v=1783950317",
  "galaxy-m34-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_M34_5G.png?v=1783950317",
  "galaxy-m33": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_M33.png?v=1784031292",
  "galaxy-m32-5g": "",
  "galaxy-m21": "",
  "galaxy-m15": "",
  "galaxy-m14-5g": "",

  "galaxy-note-20-ultra": "",
  "galaxy-note-20-ultra-5g": "",

  "galaxy-s26": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_S26.png?v=1784031285",
  "galaxy-s26-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_S26_Plus.png?v=1784031285",
  "galaxy-s26-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_S26_Ultra.png?v=1784031285",

  "galaxy-s25": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S25_c8b6d36f-7eba-41e9-b5a8-e08cc22cbab3.png?v=1784031293",
  "galaxy-s25-plus": "",
  "galaxy-s25-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S25_Ultra.png?v=1783950317",
  "galaxy-s25-edge": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S25_Edge_51c6ef8f-6105-4f84-873c-cc7f00bef59d.png?v=1784031292",
  "galaxy-s25-fe": "",

  "galaxy-s24": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S24_4d9b83ca-14bc-4cd2-8a4d-9c8e8c7f90bc.png?v=1784031292",
  "galaxy-s24-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S24_Plus_9d3d00ca-ffcc-4a77-9fae-a7a3ac2772b6.png?v=1784031293",
  "galaxy-s24-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S24_Ultra_92c288fa-7def-4c07-b267-0dfbf1eaefdf.png?v=1784031292",
  "galaxy-s24-fe": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S24_FE_5a58802e-0b79-494e-9af5-8a4c0eaf255f.png?v=1784031292",

  "galaxy-s23": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S23.png?v=1783950316",
  "galaxy-s23-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_S23_Plus.png?v=1784031292",
  "galaxy-s23-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S23_Ultra.png?v=1783950316",
  "galaxy-s23-fe": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S23_FE.png?v=1783950317",

  "galaxy-s22": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S22_6e136463-450c-4af7-82fe-14a23413650d.png?v=1784031292",
  "galaxy-s22-plus": "",
  "galaxy-s22-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S22_Ultra_6f0e5c74-16cb-492e-adec-c828453c47b7.png?v=1784031292",

  "galaxy-s21": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_S21.png?v=1784031292",
  "galaxy-s21-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_S21_Plus.png?v=1784031292",
  "galaxy-s21-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy_S21_Ultra.png?v=1784031292",
  "galaxy-s21-fe-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S21_FE_5G_2023.png?v=1783950317",

  "galaxy-s20": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy-S20.png?v=1784193992",
  "galaxy-s20-fe": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Samsung_Galaxy_S20_FE_5G.png?v=1783950317",
  "galaxy-s20-ultra": "",

  "galaxy-z-fold6": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Galaxy-Z-Fold-6.png?v=1784193992",
  "galaxy-z-fold7": "",
    // =========================
  // ONEPLUS
  // =========================

  "oneplus-ace-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus-Ace-Pro.png?v=1784031994",
  "oneplus-15r": "",
  "oneplus-15": "",
  "oneplus-13": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_13.png?v=1784031997",
  "oneplus-13s": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_13s.png?v=1784031997",
  "oneplus-13r": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_13R.png?v=1784031997",
  "oneplus-13t": "",
  "oneplus-12": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_12.png?v=1784031997",
  "oneplus-12r": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_12R.png?v=1784031997",
  "oneplus-11": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_11.png?v=1784031997",
  "oneplus-11r": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_11R.png?v=1784031997",
  "oneplus-10t": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_10T.png?v=1784031996",
  "oneplus-10-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_10_Pro.png?v=1784031997",
  "oneplus-10r": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_10R.png?v=1784031996",
  "oneplus-9r": "",
  "oneplus-9": "",
  "oneplus-8": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_8.png?v=1784031997",
  "oneplus-8t": "",
  "oneplus-8-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_8_Pro.png?v=1784031997",
  "oneplus-7-pro": "",

  "oneplus-nord-ce-5": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus-Nord-Ce5.png?v=1784031994",
  "oneplus-nord-ce-4": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_Nord_CE4.png?v=1784031997",
  "oneplus-nord-ce-4-lite": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_Nord_CE4_Lite_a7d2095c-369f-46a5-b078-45f8bbb10823.png?v=1784117935",
  "oneplus-nord-ce-3-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_Nord_CE3_5G.png?v=1784031997",
  "oneplus-nord-ce-2-5g": "",
  "oneplus-nord-ce-2-lite": "",
  "oneplus-nord-ce": "",

  "oneplus-nord-5": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus-Nord-5.png?v=1784031994",
  "oneplus-nord-4": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_Nord_4.png?v=1784031997",
  "oneplus-nord-3": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_Nord_3.png?v=1784031997",
  "oneplus-nord-2t": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oneplus_Nord_2T.png?v=1784031997",
  "oneplus-nord-2": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/OnePlus_Nord_2_5G.png?v=1784031997",

  // =========================
  // GOOGLE
  // =========================

  "google-pixel-10": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google-Pixel-10.png?v=1784112885",
  "google-pixel-10a": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google_Pixel_10A.png?v=1784112886",
  "google-pixel-10-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google-Pixel-10-Pro.png?v=1784112886",
  "google-pixel-10-pro-xl": "",
  "google-pixel-9-pro-xl": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google_Pixel_9_Pro_XL.png?v=1784112886",
  "google-pixel-8": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google_Pixel_8.png?v=1784112887",
  "google-pixel-8a": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google_Pixel_8a.png?v=1784112886",
  "google-pixel-7": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google_Pixel_7.png?v=1784112887",
  "google-pixel-7a": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google_Pixel_7A.png?v=1784112887",
  "google-pixel-7-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Google_Pixel_7_Pro.png?v=1784112887",
  "google-pixel-6a": "",
  "google-pixel-6-pro": "",

  // =========================
  // HONOR
  // =========================

  "honor-x9c": "",
  "honor-magic-6-pro": "",

  // =========================
  // INFINIX
  // =========================

  "infinix-gt-30-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Infinix-Gt-30-Pro.png?v=1784113496",
  "infinix-gt-20-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Infinix_GT_20_Pro.png?v=1784113497",
  "infinix-note-30-5g": "",
  "infinix-note-40-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Infinix_Note_40_Pro.png?v=1784194673",
  "infinix-note-40-pro-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Infinix_Note_40_Pro_Plus.png?v=1784194673",
  "infinix-note-50s": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Infinix-Note-50s.png?v=1784113496",
  "infnix-note-50s-plus": "",
  "infinix-note-50x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Infinix_Note_50x_4fb12301-dbdc-4a59-9cf3-8834af993aec.png?v=1784113497",
  "infinix-zero-30-5g": "",

  // =========================
  // IQOO
  // =========================

  "iqoo-neo-10r": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/IQOO_Neo_10r.png?v=1784113594",
  "iqoo-neo-10": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_Neo_10.png?v=1784113593",
  "iqoo-neo-9-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_Neo_9_Pro.png?v=1784113593",
  "iqoo-neo-6-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQoo_Neo_6.png?v=1784113592",

  "iqoo-15": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_15.png?v=1784113591",
  "iqoo-13": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_13.png?v=1784113593",
  "iqoo-12": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_12.png?v=1784113593",
  "iqoo-11-5g": "",
  "iqoo-9-se": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/IQOO_9SE.png?v=1784113593",
  "iqoo-7-5g": "",
  "iqoo-7-legend-5g": "",

  "iqoo-z11x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/IQOO_Z11X.png?v=1784113592",
  "iqoo-z10": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQoo_Z10.png?v=1784113593",
  "iqoo-z10-lite": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_Z10_Lite.png?v=1784113591",
  "iqoo-z10x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQoo_Z10x.png?v=1784113593",
  "iqoo-z9": "",
  "iqoo-z9s": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_Z9s.png?v=1784113593",
  "iqoo-z9s-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO-Z9s-Pro.png?v=1784193992",
  "iqoo-z7-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/iQOO_Z7_Pro.png?v=1784113593",
  "iqoo-z6-pro": "",
  "iqoo-z6-lite": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/vivo-iQOO-Z6-Lite.png?v=1784193990",
  "iqoo-z5": "",

  // =========================
  // MOTOROLA
  // =========================

  "motorola-edge-70": "",
  "motorola-edge-60": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola_Edge_60.png?v=1784114174",
  "motorola-edge-60-fusion": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola_Edge_60_Fusion.png?v=1784114174",
  "motorola-edge-60-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola_Edge_60_Pro.png?v=1784114174",
  "motorola-edge-50-neo": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola_Edge_50_Neo.png?v=1784114174",
  "motorola-edge-50-fusion": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola_Edge_50_Fusion.png?v=1784114174",
  "motorola-edge-50-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola_Edge_50_Pro.png?v=1784114174",
  "motorola-edge-50": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola-Edge-50-5G-Metal.png?v=1784193992",
  "motorola-edge-40": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola-edge-40.png?v=1784193992",
  "motorola-edge-40-neo": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola-edge-40-Neo.png?v=1784193992",
  "motorola-edge-30-fusion": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola-Edge-30-Fusion.png?v=1784193992",
  "motorola-edge-30-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola-edge-30-Ultra.png?v=1784193992",

  "motorola-g96": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Moto_G96.png?v=1784114174",
  "motorola-g86-power-5g": "",

  "moto-g85": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola-G85-5g-Metal.png?v=1784193992",
  "moto-g84": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Moto-G84.png?v=1784193992",
  "moto-g71-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Moto-G71-5G-Metal.png?v=1784193992",
  "moto-g64": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Motorola_G64_5G.png?v=1784114174",
  "moto-g54": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Moto_G54.png?v=1784114174",
  "moto-g52": "",
  "moto-g45": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Moto_G45.png?v=1784114174",
  "moto-g42": "",

  // =========================
  // NOTHING
  // =========================

  "nothing-cmf-phone-2-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Nothing_CMF_Phone_2_Pro.png?v=1784114436",
  "nothing-cmf-phone-1": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Nothing_CMF_Phone_1.png?v=1784114437",
  "nothing-phone-3a": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Nothing-Phone-3A.png?v=1783774216",
  "nothing-phone-3-5g": "",
  "nothing-phone-2a": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Nothing_Phone_2a.png?v=1784114436",
  "nothing-phone-2a-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Nothing_Phone_2a_Plus.png?v=1784114436",
  "nothing-phone-2": "",
  "nothing-phone-1": "",
    // =========================
  // OPPO
  // =========================

  "oppo-reno-15": "",
  "oppo-reno-15-pro": "",
  "oppo-reno-15-pro-mini": "",

  "oppo-reno-14": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_Reno_14.png?v=1784114532",
  "oppo-reno-14-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_Reno_14_Pro.png?v=1784114532",

  "oppo-reno-13": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_Reno_13_5G.png?v=1784114532",
  "oppo-reno-13-pro-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_Reno_13_Pro_5G.png?v=1784114532",

  "oppo-reno-12": "",

  "oppo-reno-11": "",
  "oppo-reno-11-pro": "",

  "oppo-reno-10": "",

  "oppo-reno-8t": "",
  "oppo-reno-8-5g": "",

  "oppo-reno-7": "",

  "oppo-k13": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_K13_5G.png?v=1784114533",
  "oppo-k13-turbo-5g": "",
  "oppo-k13-turbo-pro-5g": "",
  "oppo-k12x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_K12x.png?v=1784114531",

  "oppo-find-x9-pro": "",
  "oppo-find-x8": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_Find_X8_5G.png?v=1784114533",
  "oppo-find-x8-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_Find_X8_Pro_5G.png?v=1784114532",

  "oppo-f31": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo-F31.png?v=1784114530",
  "oppo-f31-pro": "",
  "oppo-f31-pro-plus-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo-F31-Pro-Plus.png?v=1784114530",

  "oppo-f29": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_F29.png?v=1784114532",
  "oppo-f29-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_F29_Pro.png?v=1784114532",

  "oppo-f27": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_F27_Metal.png?v=1784114532",
  "oppo-f25-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_F25_Pro.png?v=1784114532",
  "oppo-f21s-pro-plus-5g": "",

  "oppo-a79-5g": "",
  "oppo-a53s-5g": "",
  "oppo-a5-5g-2025": "",
  "oppo-a5-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_A5_Pro.png?v=1784114532",
  "oppo-a3-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Oppo_A3_Pro.png?v=1784114530",

  // =========================
  // REALME
  // =========================

  "realme-16-pro-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_16_Pro_Plus.png?v=1784114849",
  "realme-16-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_16_Pro.png?v=1784114850",

  "realme-15": "",
  "realme-15x": "",
  "realme-15t": "",
  "realme-15-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_15_Pro.png?v=1784114853",

  "realme-14x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme-14x-5G.png?v=1784193992",
  "realme-14t-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_14x_fd3da64b-d293-4dee-80ba-50a0bde632a0.png?v=1784114853",
  "realme-14-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_14_Pro.png?v=1784114852",
  "realme-14-pro-lite": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_14_Pro_lite.png?v=1784114852",
  "realme-14-pro-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_14_Pro_Plus.png?v=1784114852",

  "realme-13-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_13_5G.png?v=1784114853",
  "realme-13-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_13_Plus.png?v=1784114853",
  "realme-13-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_13_Pro.png?v=1784114852",
  "realme-13-pro-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme-13-Pro-Plus-5G.png?v=1784193992",

  "realme-12x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_12_X.png?v=1784195114",
  "realme-12-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_12_5G.png?v=1784114853",
  "realme-12-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_12_Plus.png?v=1784114853",
  "realme-12-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_12_Pro.png?v=1784114853",
  "realme-12-pro-plus": "",

  "realme-11-5g": "",
  "realme-11-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_11_Pro.png?v=1784114852",
  "realme-11-pro-plus": "",

  "realme-10-4g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_10.png?v=1784114852",
  "realme-10-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_10_Pro.png?v=1784114852",
  "realme-10-pro-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_10_Pro_Plus.png?v=1784114852",

  "realme-9i": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_9i.png?v=1784114852",
  "realme-9i-5g": "",
  "realme-9-se-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_9_SE.png?v=1784114852",
  "realme-9-pro-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_9_Pro.png?v=1784114853",
  "realme-9-pro-plus-5g": "",

  "realme-8-pro": "",
  "realme-7-pro": "",
  "realme-5-pro": "",

  "realme-c35": "",
  "realme-c55": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme-C55--Narzo-N55.png?v=1784193990",
  "realme-c85-5g": "",

  "realme-narzo-90": "",
  "realme-narzo-90x": "",
  "realme-narzo-80x": "",
  "realme-narzo-70x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_Narzo_70X_a3b428a1-5c15-490b-adcf-fb2fabaded69.png?v=1784195114",
  "realme-narzo-70-pro": "",
  "realme-narzo-60x": "",
  "realme-narzo-50i": "",
  "realme-narzo-n65": "",
  "realme-narzo-n55": "",

  "realme-gt-8-pro": "",
  "realme-gt-7-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme-GT-7-Pro.png?v=1784114849",
  "realme-gt-neo-3t": "",
  "realme-gt-2": "",
  "realme-gt-neo-2": "",
  "realme-gt-master-edition": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme-GT-Master-Edition.png?v=1784193992",

  "realme-p4": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_P4_5G.png?v=1784114853",
  "realme-p3": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_P3.png?v=1784114853",
  "realme-p3x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_P3x.png?v=1784114849",
  "realme-p3-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme-P3-Pro-5G.png?v=1784193992",
  "realme-p3-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_P3_Ultra.png?v=1784114852",
  "realme-p1": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Realme_P1_5G.png?v=1784114852",
    // =========================
  // VIVO
  // =========================

  "vivo-t4": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T4.png?v=1784116155",
  "vivo-t4x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T4x.png?v=1784116157",
  "vivo-t4-lite": "",
  "vivo-t4x-lite": "",
  "vivo-t4-pro-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T4_Pro.png?v=1784116157",
  "vivo-t4-ultra-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T4_Ultra.png?v=1784116156",
  "vivo-t3-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T3.png?v=1784116157",
  "vivo-t3x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T3X.png?v=1784116156",
  "vivo-t3-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T3_Pro.png?v=1784116155",
  "vivo-t3-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T3_Ultra.png?v=1784116153",
  "vivo-t2-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_T2_Pro.png?v=1784116156",
  "vivo-t1-44w": "",

  "vivo-v70-elite": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V70_Elite.png?v=1784116151",
  "vivo-v70-fe": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V70_FE_5G.png?v=1784116149",
  "vivo-v70": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V70.png?v=1784116150",
  "vivo-v60e": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo-V60E.png?v=1784116150",
  "vivo-v60-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V60.png?v=1784116156",
  "vivo-v40": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V40.png?v=1784116154",
  "vivo-v40e": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V40e.png?v=1784116157",
  "vivo-v40-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V40_Pro.png?v=1784116152",
  "vivo-v30": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V30.png?v=1784116157",
  "vivo-v30e": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V30e.png?v=1784116156",
  "vivo-v30-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V30_Pro.png?v=1784116157",
  "vivo-v29": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/vivo-V29.png?v=1784193992",
  "vivo-v29-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/VIvo_V29_Pro.png?v=1784193992",
  "vivo-v29e": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo-V29e-5G.png?v=1784193992",
  "vivo-v27": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V27.png?v=1784116154",
  "vivo-v27-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V27_Pro.png?v=1784116154",
  "vivo-v25": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V25.png?v=1784116156",
  "vivo-v25-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_V25_Pro.png?v=1784116155",
  "vivo-v17": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo-V17.png?v=1784193992",
  "vivo-v11-pro": "",

  "vivo-x300-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_X300_Ultra_5G.png?v=1784116147",
  "vivo-x300-pro": "",
  "vivo-x300": "",
  "vivo-x200-fe": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_X200_FE.png?v=1784116156",
  "vivo-x200-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_X200_Pro.png?v=1784116156",
  "vivo-x200": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_X200_815688fc-f695-49b9-a0e3-0969c458f9db.png?v=1784116157",
  "vivo-x100-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo-X100-Pro-5G-Metal.png?v=1784193992",
  "vivo-x100": "",
  "vivo-x90-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_X90_Pro.png?v=1784116156",
  "vivo-x80-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_X80_Pro.png?v=1784116154",
  "vivo-x80": "",
  "vivo-x70-pro-plus": "",
  "vivo-x70-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/VIvo_X70_Pro.png?v=1784116147",
  "vivo-x60-pro": "",

  "vivo-y400-5g": "",
  "vivo-y400-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y400_Pro.png?v=1784116157",
  "vivo-y300-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y300_Plus.png?v=1784116156",
  "vivo-y300": "",
  "vivo-y200": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y200.png?v=1784116156",
  "vivo-y200e": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y200e.png?v=1784116157",
  "vivo-y200i": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y200i.png?v=1784116157",
  "vivo-y200-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y200_Pro.png?v=1784116157",
  "vivo-y100": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y100.png?v=1784116156",
  "vivo-y75-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y75_5G.png?v=1784116157",
  "vivo-y58": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo-Y58-5G-Metal.png?v=1784193992",
  "vivo-y56": "",
  "vivo-y39": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y39.png?v=1784116156",
  "vivo-y38": "",
  "vivo-y33-s": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y33S.png?v=1784116157",
  "vivo-y33-t": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y33T.png?v=1784116156",
  "vivo-y31-pro-5g": "",
  "vivo-y29": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y29.png?v=1784116157",
  "vivo-y29-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y29_Pro.png?v=1784116157",
  "vivo-y28": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo-Y28-5G-Metal.png?v=1784193992",
  "vivo-y22": "",
  "vivo-y19": "",
  "vivo-y05": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Vivo_Y05.png?v=1784116149",

  // =========================
  // XIAOMI
  // =========================

  "xiaomi-17": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Xiaomi_17_5G.png?v=1784115509",
  "xiaomi-17-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Xiaomi_17_Ultra.png?v=1784115508",
  "xiaomi-15": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Xiaomi_15_5G.png?v=1784115509",
  "xiaomi-15-ultra": "",
  "xiaomi-14": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Xiomi-14.png?v=1784193992",
  "xiaomi-14-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Xiomi-14-Pro.png?v=1784193992",
  "xiaomi-14-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Xiaomi-14-ultra-metal.png?v=1784193992",
  "xiaomi-14-civi": "",
  "xiaomi-13-ultra": "",

  "xiaomi-11i-5g": "",
  "xiaomi-11i-hypercharge": "",

  "mi-11-ultra": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Mi11-Ultra.png?v=1784193992",
  "mi-11x": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/mi-11-x.png?v=1784193992",
  "mi-11x-pro": "",
  "mi-11-lite-ne-5g": "",
  "mi-10i": "",

  // =========================
  // REDMI
  // =========================

  "redmi-15c": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi-15C.png?v=1784115918",
  "redmi-15-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_15_5G.png?v=1784115507",
  "redmi-14c": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_14c.png?v=1784115509",
  "redmi-13-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_13_5G.png?v=1784115509",
  "redmi-13c-5g": "",

  "redmi-a7-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_A7_Pro.png?v=1784115507",
  "redmi-a5-4g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Readmi_A5_4G.png?v=1784115509",
  "redmi-a4": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_A4.png?v=1784115509",

  "redmi-note-15": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi-Note-15.png?v=1784115507",
  "redmi-note-15-se": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_15_SE.png?v=1784116071",
  "redmi-note-15-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi-Note-15-pro.png?v=1784115507",
  "redmi-note-15-pro-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_15_Pro_Plus.png?v=1784115507",

  "redmi-note-14-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_14.png?v=1784115509",
  "redmi-note-14-pro-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_14_Pro.png?v=1784115509",
  "redmi-note-14-pro-plus-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_14_Pro_Plus_5G.png?v=1784115509",

  "redmi-note-13-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_13_5G.png?v=1784115509",
  "redmi-note-13-pro-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_13_Pro.png?v=1784115509",
  "redmi-note-13-pro-plus-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi_Note_13_Pro_Plus.png?v=1784115509",

  "redmi-note-12-5g": "",

  "redmi-note-10t": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Redmi-Note-10T-5G.png?v=1784193992",
  "redmi-note-10s": "",
  "redmi-note-10-pro": "",
  "redmi-note-10-pro-max": "",

  "redmi-note-9": "",
  "redmi-note-9-pro": "",
  "redmi-note-9-pro-max": "",

  "redmi-note-8": "",
  "redmi-note-7s": "",

  // =========================
  // POCO
  // =========================

  "poco-c85x-5g": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_C85x_5G.png?v=1784115312",
  "poco-c81": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_C81.png?v=1784115313",
  "poco-c75": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_C75.png?v=1784115314",
  "poco-c71": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_C71.png?v=1784115314",
  "poco-c55": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_C55.png?v=1784115313",

  "poco-m8": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_M8.png?v=1784115312",
  "poco-m8-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_M8_Pro.png?v=1784115312",
  "poco-m7": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_M7.png?v=1784115314",
  "poco-m7-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_M7_Pro.png?v=1784115314",
  "poco-m6-plus": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_M6_Plus_5G.png?v=1784115314",
  "poco-m6-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_M6_Pro.png?v=1784115314",

  "poco-x6": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_X6_f96b28d0-74e5-4715-84ae-2a5e3f7f22d0.png?v=1784115313",
  "poco-x6-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_X6_Pro.png?v=1784115313",
  "poco-x7": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_X7_48e11175-e449-4dda-a309-e1634845d53e.png?v=1784115314",
  "poco-x7-pro": "https://cdn.shopify.com/s/files/1/0894/5706/6267/files/Poco_X7_Pro.png?v=1784115313",

  // =========================
  // TECNO
  // =========================

  "tecno-camon-20": "",
  "tecno-pova-6-pro": "",
  "tecno-pova-7-5g": "",
  "tecno-pova-7-pro-5g": ""

};